<template>
    <div>
        <ob1-cards class="bg-white p-1" :with-composite-link="false">
            <div class="d-flex flex-row justify-content-center">
                <div class="ob1-skeleton ">
                    <div class="ob1-skeleton-white mb-1" style="width: 100px; height: 30px" />
                </div>
            </div>
            <div class="d-flex flex-row justify-content-center">
                <div class="ob1-skeleton ">
                    <div class="ob1-skeleton-white mb-1" style="width: 200px; height: 30px" />
                </div>
            </div>
            <div class="d-flex flex-row justify-content-center">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white mb-1" style="width: 140px; height: 175px" />
                </div>
            </div>
        </ob1-cards>
    </div>
</template>

<script>
export default {
    name: "SkeletonMobileViewsHistoryCard",
}
</script>
